export default {
    SUBMIT_IMPORTAR_CONTACTOS_EXCEL: 'SUBMIT_IMPORTAR_CONTACTOS_EXCEL',
    SUBMIT_IMPORTAR_CONTACTOS_EXCEL_SUCCESS: 'SUBMIT_IMPORTAR_CONTACTOS_EXCEL_SUCCESS',
    ABRIR_MODAL_IMPORTAR_CONTACTOS_EXCEL: 'ABRIR_MODAL_IMPORTAR_CONTACTOS_EXCEL',
    CERRAR_MODAL_IMPORTAR_CONTACTOS_EXCEL: 'CERRAR_MODAL_IMPORTAR_CONTACTOS_EXCEL',
    SUBIR_ARCHIVOS_IMPORTAR_CONTACTOS_EXCEL: 'SUBIR_ARCHIVOS_IMPORTAR_CONTACTOS_EXCEL',
    DESCARGAR_PLANTILLA_EXCEL_CONTACTOS_EXCEL: 'DESCARGAR_PLANTILLA_EXCEL_CONTACTOS_EXCEL',
    DESCARGAR_CONTACTOS_EXCEL: 'DESCARGAR_CONTACTOS_EXCEL'
  }